export default function Breadcrumb({ items }: { items: { label: string; href?: string }[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs text-foreground-500 py-3 flex-wrap">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-2">
          {i > 0 && (
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-xs"></i>
            </span>
          )}
          {item.href ? (
            <a href={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
              {item.label}
            </a>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}